// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__Ux6SD","info":"Note_info__TuJ-h","note":"Note_note__1Q89G","actions":"Note_actions__2cvuq"};